export const getMarkdownEndpoint = () => `${process.env.REACT_APP_ENDPOINT}/settings/text-resources`
